import { ActionPanel } from '~/components/action-panel';
import { FC, useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { $SharePanelOpen } from '~/models/portal/share-panel';
import { StepScroll } from '../step-scroll';
import { useShareConfig } from './config';
import cls from 'classnames';
import { useResetAtom } from 'jotai/utils';

import './style.scss';

export const SharePanel: FC = () => {
  const sharePanelValue = useAtomValue($SharePanelOpen);
  const closeSharePanel = useResetAtom($SharePanelOpen);

  const handleClose = useCallback(() => {
    closeSharePanel();
  }, []);

  const shareConfig = useShareConfig({
    handleClose: closeSharePanel,
    title: sharePanelValue ? sharePanelValue.title : '',
    href: sharePanelValue ? sharePanelValue.href : '',
  });

  return (
    <ActionPanel
      className="share-panel"
      open={Boolean(sharePanelValue)}
      title="Send To"
      onClickMask={handleClose}
      onClickClose={handleClose}
    >
      <StepScroll className="share-panel-content">
        {shareConfig.map((item) => (
          <div key={item.text} className={cls('share-panel-content-item', item.className)} onClick={item.onClick}>
            <div className="share-panel-content-item-icon" style={{ backgroundColor: item.color }}>
              <item.Icon />
            </div>
            <span>{item.text}</span>
          </div>
        ))}
      </StepScroll>
    </ActionPanel>
  );
};
